<template>
  <div class="text-base text-neutral-500">
    <component
      :is="data.reference !== null ? NuxtLink : data.externalLink ? NuxtLink : 'span'"
      :to="
        data.reference
          ? usePathByType(data.reference._modelApiKey, data.reference.slug!)
          : data.externalLink
            ? data.externalLink
            : undefined
      "
      class="w-fit transition-colors duration-300 hover:text-neutral-700"
      ><span class="mb-2 inline-block font-bold uppercase">
        {{ data.title }}
      </span>
    </component>
    <ul v-if="Array.isArray(data.children) && data.children.length" class="text-sm lg:text-base">
      <li v-for="item in data.children" :key="item!.id">
        <NuxtLink
          :to="
            item!.reference
              ? usePathByType(item!.reference._modelApiKey, item!.reference.slug!)
              : item!.externalLink
          "
          class="block w-fit py-1 transition-colors duration-300 hover:text-neutral-700"
          >{{ item!.title }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { FooterMenuItemRecord } from '~/types/datocms'

const NuxtLink = resolveComponent('NuxtLink')

defineProps({
  data: {
    type: Object as PropType<FooterMenuItemRecord>,
    default: () => {}
  }
})
</script>
